import { FileTextIcon, FolderIcon } from "lucide-react";
import * as React from "react";
import { Item } from "@/types/fse";

const MAX_DISPLAY_NAME_LENGTH = 30;

interface Props {
  item: Item;
  additionalCount: number;
}

export const DragOverlayContent: React.FC<Props> = ({ item, additionalCount }) => {
  const displayName =
    item.name.length > MAX_DISPLAY_NAME_LENGTH ? item.name.substring(0, MAX_DISPLAY_NAME_LENGTH) + "..." : item.name;

  const Icon = item.type === "folder" ? FolderIcon : FileTextIcon;
  const iconClassName = item.type === "folder" ? "text-brand-gold-700" : "text-blue-600";

  return (
    <div className="flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 shadow-lg">
      <Icon className={`h-5 w-5 ${iconClassName}`} />
      <span className="font-medium text-gray-700">{displayName}</span>
      {additionalCount > 0 && (
        <span className="rounded-full bg-blue-500 px-2 py-0.5 text-xs font-medium text-white">
          +{additionalCount} more
        </span>
      )}
    </div>
  );
};
